export const orderConfirmClientDefaultTemplate = `lexical:
<p style="margin-top: 1em; text-align: center;">
	<img src="https://connectico.pl/wp-content/uploads/2020/04/cropped-connectico_logo_color_extra_small.png" style="display: block; margin-left: auto; margin-right: auto;" />
</p>

<p style="margin-top: 1em;">&nbsp;</p>

<p style="text-align: center; margin: 2em 0 1em 0;">
	<strong style="font-size: 1.4em;">Dziękujemy za zamówienie</strong>
</p>

<p style="text-align: center; margin: 0 0 2em 0;">
	Otrzymaliśmy Twoje zamówienie <strong>{numer_zamowienia}</strong> i rozpoczęliśmy jego realizację.
</p>

<table style="border-collapse: collapse; border-spacing: 0; width: auto; table-layout: auto; margin-left: auto; margin-right: auto;">
		<tbody>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Numer zamówienia:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{numer_zamowienia}</p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Zamawiający:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{zamawiajacy_nazwa_firmy_imie_nazwisko}</p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>NIP:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{zamawiajacy_nip}</p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Data:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{data_godzina_zamowienia}</p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Wartość zamówienia:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p><strong>{zamowienie_wartosc_brutto} {waluta}</strong></p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Forma płatności:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{forma_platnosci}</p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Forma dostawy:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{forma_dostawy}</p></td>
				</tr>
				<tr>
						<td style="padding: 0.2em 1em; background-color: #f2f3f5; text-align: right; vertical-align: top;"><p><strong>Adres dostawy:</strong></p></td>
						<td style="padding: 0.2em 1em; vertical-align: top;"><p>{adres_dostawy}</p></td>
				</tr>
		</tbody>
</table>

<p style="margin-top: 2em;">&nbsp;</p>

<p style="margin: 2em 0 1em 0; text-align: center;">
	<strong style="font-size: 1.4em;">Zamówione produkty</strong>
</p>

<p style="margin: 0 0 2em 0; text-align: center;">
	{tabela_zamowionych_produktow}
</p>

<table style="border-collapse: collapse; border-spacing: 0; width: 100%; max-width: 700px; table-layout: auto; margin-left: auto; margin-right: auto; border: 1px solid #d9dce1; background-color: #f9fafb;">
		<tbody>
				<tr>
						<td style="padding: 1em 1.2em; vertical-align: top;">
								<p><strong>Uwagi do zamówienia:</strong></p>
								<p>{uwagi}</p>
								<p style="margin-top: 1em;"><strong>Płatność przedpłata / proforma</strong></p>
								<p>Jeśli wybrałeś tę formę płatności, możesz już teraz opłacić zamówienie, podając jego numer.</p>
								<p><strong>mBank S.A.</strong><br/>77 1140 2004 0000 3402 3478 4468<br/>MS Systems, ul. Połabian 68, 52-339 Wrocław</p>
								<p style="margin-top: 1em;">Do realizacji zamówienia niezbędny jest numer NIP licencjobiorcy.</p>
						</td>
				</tr>
		</tbody>
</table>

<p style="margin-top: 2em; text-align: center; color: #666;">
	Jeśli posiadasz konto w naszym sklepie, zaloguj się i śledź status realizacji zamówienia.
</p>

<p style="margin-top: 1.2em; text-align: center; color: #666;">
	W razie pytań skontaktuj się z nami: sklep@wapro-programy.pl, tel. 717 967 298.
</p>
`;
/*
Dziękujemy!

Otrzymaliśmy Twoje zamówienie

Informacje o zamówieniu:

Numer zamówienia:	{numer_zamowienia}
Zamawiający:	{zamawiajacy_nazwa_firmy_imie_nazwisko} , NIP: {zamawiajacy_nip}
Data:	{data_godzina_zamowienia}
Wartość zamówienia:	{zamowienie_wartosc_brutto}
Forma płatności:	{forma_platnosci}
Forma dostawy:	{forma_dostawy}
Adres dostawy:	{adres_dostawy}

Zamówione produkty:
{tabela_zamowionych_produktow}

Uwagi:
{uwagi}

Jeśli jako formę płatności wybrałeś przedpłatę / proformę to już teraz możesz opłacić zamówienie (podając jego numer)  przelewem na nasze konto:
mBank S.A.
77 1140 2004 0000 3402 3478 4468
MS Systems, ul. Połabian 68, 52-339 Wrocław

Uwaga: Do realizacji zamówienia jest niezbędny numer NIP licencjobiorcy. Jeśli nie podałeś go w procesie składania zamówienia, prześlij go do nas w kolejnej wiadomości.

Jeśli posiadasz konto w naszym sklepie zaloguj się i śledź stan realizacji Twojego zamówienia
Zaloguj się

W przypadku pytań skontaktuj się z nami:

Sklep wapro-programy.pl

MS Systems - Złoty Partner WAPRO ERP

ul. Połabian 68, 52-339 Wrocław

tel.: 717 967 298, e-mail: sklep@wapro-programy.pl

 Informacje, które zawiera niniejsza korespondencja są poufne i skierowane tylko i wyłącznie do adresata. Jeśli e-mail odebrany został przypadkowo lub w wyniku zaistniałej pomyłki przez osobę inną niż adresat, uprzejmie prosimy odbiorcę o natychmiastowe powiadomienie nadawcy i skasowanie wiadomości e-mail. Jeżeli odbiorca nie jest adresatem wiadomości, niniejszym informujemy, iż zapoznawanie się z treścią, którą ona zawiera, jej kopiowanie i rozpowszechnianie jest nieuprawnione.
 */